import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApp, API, LOGO_URL, WHATSAPP_URL, TELEGRAM_URL } from "../store";
import axios from "axios";
import { Instagram, Youtube, Twitter, MapPin, Mail, MessageCircle, Send } from "lucide-react";

export default function Footer() {
  const { t, locale } = useApp();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email, locale });
      setMsg(t.news.ok); setEmail("");
    } catch { setMsg("Error"); }
  };

  return (
    <footer className="bg-white border-t border-slate-200 mt-24" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="overline mb-4">{t.news.overline}</div>
          <h3 className="font-serif-display text-4xl md:text-5xl mb-6 text-slate-900">{t.news.title}</h3>
          <p className="text-slate-600 max-w-md mb-8">{t.news.body}</p>
          <form onSubmit={submit} className="flex gap-3 max-w-md flex-wrap" data-testid="newsletter-form">
            <input value={email} onChange={(e) => setEmail(e.target.value)} required type="email" placeholder={t.news.placeholder}
              className="flex-1 min-w-[200px] bg-white border border-slate-300 px-5 py-3 text-slate-900 placeholder-slate-400 focus:border-sky-500 focus:outline-none rounded-md"
              data-testid="newsletter-email" />
            <button type="submit" className="btn-primary" data-testid="newsletter-submit">{t.news.cta}</button>
          </form>
          {msg && <div className="text-sky-500 text-sm mt-3 font-ui" data-testid="newsletter-msg">{msg}</div>}
          <div className="mt-6">
            <div className="overline mb-3">{t.news.channels}</div>
            <div className="flex gap-3">
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-xs uppercase tracking-widest font-ui font-semibold transition-colors"
                data-testid="news-whatsapp">
                <MessageCircle size={14} /> {t.news.whatsapp}
              </a>
              <a href={TELEGRAM_URL} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-500 hover:bg-sky-600 text-white text-xs uppercase tracking-widest font-ui font-semibold transition-colors"
                data-testid="news-telegram">
                <Send size={14} /> {t.news.telegram}
              </a>
            </div>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-5">{t.footer?.shop || "Shop"}</div>
          <div className="flex flex-col gap-3 text-slate-600 text-sm">
            <Link to="/products/efoils" className="hover:text-sky-500">{t.nav.efoils}</Link>
            <Link to="/products/jetboards" className="hover:text-sky-500">{t.nav.jetboards}</Link>
            <Link to="/products/SharkX-Ultra-AI-electric-jetski" className="hover:text-sky-500">{t.nav.ultra}</Link>
            <Link to="/products/accessories" className="hover:text-sky-500">{t.nav.accessories}</Link>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-5">{t.footer?.company || "Company"}</div>
          <div className="flex flex-col gap-3 text-slate-600 text-sm">
            <Link to="/blog" className="hover:text-sky-500">{t.nav.blog}</Link>
            <Link to="/book" className="hover:text-sky-500">{t.nav.book}</Link>
            <Link to="/contact" className="hover:text-sky-500">{t.nav.contact}</Link>
            <Link to="/admin/login" className="hover:text-sky-500">{t.nav.admin}</Link>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">{t.footer?.follow || "Follow"}</div>
          <div className="flex gap-3">
            <a href="https://www.instagram.com/sharkxelectric" target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-slate-200 rounded-full hover:border-sky-500 hover:text-sky-500 text-slate-600" aria-label="Instagram"><Instagram size={16} /></a>
            <a href="https://youtu.be/B850Uw0n9OE" target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-slate-200 rounded-full hover:border-sky-500 hover:text-sky-500 text-slate-600" aria-label="YouTube"><Youtube size={16} /></a>
            <a href={TELEGRAM_URL} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-slate-200 rounded-full hover:border-sky-500 hover:text-sky-500 text-slate-600" aria-label="Telegram"><Send size={16} /></a>
            <a href="#" className="w-10 h-10 grid place-items-center border border-slate-200 rounded-full hover:border-sky-500 hover:text-sky-500 text-slate-600" aria-label="Twitter"><Twitter size={16} /></a>
          </div>
          <div className="overline mt-8 mb-3">{t.footer.pay}</div>
          <div className="flex flex-wrap gap-2 text-[10px] font-ui uppercase tracking-widest text-slate-600">
            <span className="px-3 py-1.5 border border-slate-200 rounded">Credit Card</span>
            <span className="px-3 py-1.5 border border-slate-200 rounded">Crypto - USDT</span>
            <span className="px-3 py-1.5 border border-slate-200 rounded">PIX</span>
          </div>
          <div className="mt-8 space-y-2 text-sm text-slate-600">
            <div className="flex items-start gap-2"><MapPin size={14} className="mt-1 flex-shrink-0 text-sky-500" /> Florianópolis - Brazil</div>
            <div className="flex items-start gap-2"><Mail size={14} className="mt-1 flex-shrink-0 text-sky-500" /> sales@sharkxelectric.com</div>
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex items-start gap-2 hover:text-emerald-600" data-testid="footer-whatsapp">
              <MessageCircle size={14} className="mt-1 flex-shrink-0 text-emerald-500" /> WhatsApp
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-200 px-6 md:px-12 py-6 max-w-[1440px] mx-auto flex flex-col md:flex-row items-center justify-between text-xs text-slate-500 font-ui tracking-wider">
        <div>© {new Date().getFullYear()} SharkX Electric. {t.footer.rights}</div>
        <div className="mt-2 md:mt-0">{t.footerTagline}</div>
      </div>
      <div id="openclaw-widget" data-testid="openclaw-widget"></div>
    </footer>
  );
}
